// extracted by mini-css-extract-plugin
module.exports = {"list":"Breadcrumbs_list__S8D2I","noMargin":"Breadcrumbs_noMargin__uYKgw"};